import { genId } from '@/utils/id'
import { seedInfoItems } from '@/mock/seed'

// 模擬「貼上網址後由伺服器自動抓取標題/縮圖」（4.4.1）。
function detectKind (url) {
  if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube'
  if (/instagram\.com/i.test(url)) return 'instagram'
  return 'web'
}

const KIND_ICON = { youtube: '📺', instagram: '📷', web: '🔗', note: '📝' }

export function mockFetchMeta (url) {
  const kind = detectKind(url)
  let title = url
  try {
    const u = new URL(url)
    title = u.pathname.replace(/\W+/g, ' ').trim() || u.hostname
  } catch (e) {
    title = url
  }
  return {
    kind,
    title: title.length > 60 ? title.slice(0, 60) + '…' : title,
    thumbnail: KIND_ICON[kind]
  }
}

export default {
  namespaced: true,
  state: {
    list: seedInfoItems
  },
  getters: {
    byTrip: state => tripId => state.list.filter(i => i.tripId === tripId),
    byPoint: state => pointId => state.list.filter(i => i.pointIds.includes(pointId))
  },
  mutations: {
    ADD_ITEM (state, item) {
      state.list.unshift(item)
    },
    UPDATE_ITEM (state, { id, patch }) {
      const item = state.list.find(x => x.id === id)
      if (item) Object.assign(item, patch)
    },
    REMOVE_ITEM (state, id) {
      state.list = state.list.filter(x => x.id !== id)
    }
  },
  actions: {
    addFromUrl ({ commit }, { tripId, url, note, pointIds, tags, createdBy, visibility }) {
      const meta = url ? mockFetchMeta(url) : { kind: 'note', title: note ? note.slice(0, 30) : '筆記', thumbnail: '📝' }
      const id = genId()
      commit('ADD_ITEM', {
        id,
        tripId,
        url: url || '',
        kind: meta.kind,
        title: meta.title,
        thumbnail: meta.thumbnail,
        note: note || '',
        pointIds: pointIds || [],
        tags: tags || [],
        createdBy,
        visibility: visibility || 'trip'
      })
      return id
    },
    updateItem ({ commit }, payload) {
      commit('UPDATE_ITEM', payload)
    },
    removeItem ({ commit }, id) {
      commit('REMOVE_ITEM', id)
    }
  }
}
